import { Component, OnInit } from '@angular/core';
import { faMapPin ,faLaptop, faTicketAlt, faCogs, faFileInvoice, faCreditCard, faUsersCog, faListOl, faSearch ,faWarehouse, faHandsHelping, faKey, faUserCog, faTimes ,faPuzzlePiece, faTv, faBed, faHome, faBuilding, faUserCheck, faRunning, faLaptopHouse, faRupeeSign, faMobileAlt, faFileSignature, faBroom, faToolbox, faCouch, faWater, faChartPie, faChartBar, faUserTie, faChartLine, faUserShield, faFile, faCalendarAlt, faCoins, faHardHat, faHouseUser, faHammer, faPlay, faNotesMedical, faThumbsUp, faTools, faCheck, faCity, faPaintRoller } from '@fortawesome/free-solid-svg-icons'
import { Router} from "@angular/router";
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { gutil} from '../gutil';
import * as AOS from 'aos';
import * as moment from 'moment';


@Component({
  selector: 'app-property-manager',
  templateUrl: './property-manager.component.html',
  styleUrls: ['./property-manager.component.scss']
})
export class PropertyManagerComponent implements OnInit {

  constructor(private http: HttpClient, private router: Router) { 

  }

  public faMapPin = faMapPin;
  public faLaptop = faLaptop;
  public faTicket = faTicketAlt;
  public faCogs = faCogs;
  public faFileInvoice = faFileInvoice;
  public faCreditCard = faCreditCard;
  public faUsersCog = faUsersCog;
  public faListOl = faListOl;
  public faSearch = faSearch;
  public faCity = faCity;
  public faPuzzle = faPuzzlePiece;
  public faWarehouse = faWarehouse;
  public faPaintRoller= faPaintRoller;
  public faPlay = faPlay;
  public faUserCheck = faUserCheck;
  public faCheck = faCheck;
  public faHammer = faHammer;
  public faUserTie = faUserTie;
  public faHomeUser = faHouseUser;
  public faHardHat = faHardHat;
  public faCoins = faCoins;
  public faUserShield = faUserShield;
  public faFile = faFile;
  public faFileSign = faFileSignature;
  public faBroom  = faBroom;
  public faTools = faToolbox;
  public faTool = faTools;
  public faSofa = faCouch;
  public faWater = faWater;
  public faChartLine = faChartLine
  public faChart = faChartBar;
  public faRunning = faRunning;
  public faWFH = faLaptopHouse;
  public faRupee = faRupeeSign;
  public faMobile = faMobileAlt;
  public faTv = faTv;
  public faBed = faBed;
  public faHome = faHome;
  public faHealth = faNotesMedical;
  public faThumbsUp = faThumbsUp;
  public faBuilding = faBuilding;
  public testimonial_owner : Array<any> = [];
  public faHandsHelping = faHandsHelping;
  public faKey = faKey;
  public faUserCog = faUserCog;
  public faTimes = faTimes;
  public faCalendarAlt = faCalendarAlt;
  public selectedModel : number;
  public tempLoad : boolean;

  public cityList : Array<any>;
  public stateList : Array<any>;
  public tenantType : Array<any>;
  public genderType: Array<any>;

  public selectedCity: string;
  public selectedState : string;  
  public selectedTenantType: string;
  public selectedGenderType: string;

  public owner = {name : "", address: "", city: "", state: "", zip: '', phone: "", tenant: '', gender: '', rent: '', deposit: '', serviceReq: '', start_date: '', service_detail: ''}
  public propImages : Array<any>;
  public rentalMngtServices : boolean = true;
  public propertyMngtServices : boolean;
  public managementServices : any;
  public serviceList : Array<any>;
  public serviceType : any;
  public mngtServiceType: string;
  public selectedMngtServiceName : string;


  ngOnInit(): void {
    window.scroll(0,0);
    AOS.init();
    
    this.selectedModel = 1;
    
    this.tempLoad = false;
    this.loadData();
    this.cityList = gutil.citySel;
    this.stateList = gutil.stateSel;
    this.tenantType = gutil.propTypeSel;
    this.genderType = gutil.genderSel;
    this.owner.city = 'city';
    this.owner.state = 'state';
    this.owner.gender = 'gender';
    this.owner.tenant = 'tenant';
    this.serviceList = gutil.srTypesSel;
    this.managementServices = 'rms';
    this.serviceType = 'service_type';

    this.mngtServiceType = "pms"
    this.selectedMngtServiceName = "residential";
  }
  
  public loadData() {
    var imgs = document.querySelectorAll('[data-src]');
    
    var imgOptions = {
      threshold : 0,
      rootMargin : "0px 0px 300px 0px"
    };

    var imgObserver = new IntersectionObserver((entries, imgObserver) => {
      entries.forEach(entry => {
        if(!entry.isIntersecting) {
          return;
        }
        else {
          this.preLoadImage(entry.target);
          imgObserver.unobserve(entry.target);
        }
      })
    }, imgOptions)

    imgs.forEach(image => {
      imgObserver.observe(image);
    })
  }


  public preLoadImage(img: any){
    var src = img.getAttribute("data-src"); 
    if(!src){
      return;
    }

    img.src = src;
  } 
  public selectModel(type: number){
    this.selectedModel = type;
    if(type == 1){
      document.getElementById('model1').classList.add("active");
      document.getElementById('model2').classList.remove('active');
    }
    if(type == 2){
      document.getElementById('model1').classList.remove("active");
      document.getElementById('model2').classList.add('active');
    }
    if(type == 3){
      this.selectedModel = 1;
      document.getElementById('mob_model1').classList.add("active");
      document.getElementById('mob_model2').classList.remove('active');
    }
    if(type == 4){
      this.selectedModel = 2;
      document.getElementById('mob_model1').classList.remove("active");
      document.getElementById('mob_model2').classList.add('active');
    }
    
  }
  public exploreModel(mType: number){
    if(mType == 1){
      let el = document.getElementById('value_prop_1');
      el.scrollIntoView({behavior: 'smooth'});
    }
    if(mType == 2){
      let el = document.getElementById('value_prop_2');
      el.scrollIntoView({behavior: 'smooth'})
    }
  } 
  public newsRight() {
    let content = document.getElementById('news_carousal');
    this.slideScroll(content,'right',25,150,260);
  }
  public newsLeft() {
    let content = document.getElementById('news_carousal');
    this.slideScroll(content,'left',25,150,260);
  }
  public scrollRight() {
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'right',50,300,380);
  }
  public scrollLeft() {
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'left',50,300,380);
  }
  public developerLeft(){
    let content = document.getElementById('developers_carousal');
    this.slideScroll(content,'left',25,150,260);
  }
  public developerRight(){
    let content = document.getElementById('developers_carousal');
    this.slideScroll(content,'right',25,150,260);
  }
  public developerPuneLeft(){
    let content = document.getElementById('developers_pune_carousal');
    this.slideScroll(content,'left',25,150,260);
  }
  public developerPuneRight(){
    let content = document.getElementById('developers_pune_carousal');
    this.slideScroll(content,'right',25,150,260);
  }
  public blogLeft() {
    let content = document.getElementById('blogs_carousal');
    this.slideScroll(content,'left',50,300,370);
  }
  public blogRight(){
    let content = document.getElementById('blogs_carousal');
    this.slideScroll(content,'right',50,300,370);
  }
  public videoTestimonialRight(){
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'right',50,300,230);
  }
  public videoTestimonialLeft(){
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'left',50,300,230);
  }  
  public slideScroll(element : any,direction: string,speed: number,distance: number,step: number){
    let scrollAmount = 0;
    let slideTimer = setInterval(function(){
      if(direction == 'left'){
        element.scrollLeft -= step;
      }else{
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount >=distance ){
        window.clearInterval(slideTimer);
      }
    }, speed)
  }

  //
  public onCityChange(value: any) {    
    this.owner.city = value;
  }
  public onAddressChange(value: any) {    
    this.owner.address = value;
  }
  public onStateChange(value: any) {    
    this.owner.state = value;
  }
  public onZipChange(value: any) {    
    this.owner.zip = value;
  }
  public onOwnerNameChange(value: any) {    
    this.owner.name = value;
  }
  public onOwnerPhoneChange(value: any) {    
    this.owner.phone = value;
  }
  public onRentChange(value: any) {    
    this.owner.rent = value;
  }
  public onDepositChange(value: any) {    
    this.owner.deposit = value;
  }
  public onTenantTypeChange(value: any) {
    this.owner.tenant = value;
  }
  public onGenderChange(value: any) {
    this.owner.gender = value;
  }
  public onAddImagesUpload(value: any) {
    let fileList: FileList = value.target.files;
    
    if(fileList.length > 0) {                
      let j =0;
        for(let i = 0; i < fileList.length; i++) {          
          // console.log(fileList[i]);
          this.propImages[j] = fileList[i];
          j++;
        }
        console.log(this.propImages);
    }    
  }

  public onServiceTypeChange(value: any) {

  }
  public onStartDateChange(value: any) {

  }
  public onServiceDetailChange(value: any) {

  }
  public onAddDefectImagesUpload(value: any) {
    
  }
  public onRentalProgramChange(value: any) {
    console.log(value);
    if(value == 'rms') {
      this.rentalMngtServices = true;
      this.propertyMngtServices = false
    }
    else {
      this.propertyMngtServices = true;
      this.rentalMngtServices = false;
    }
  }

  public onSubmitPropertyListing() {    

    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'}); // //multipart/form-data
    let options =  {headers: headers };
    let params = new URLSearchParams();
      
  }
  public changeMngtServices(val: any) {    
    console.log(val);

    if(val == "rrm") {                    //rrm means Residential Rental Management
      this.mngtServiceType = "pms";       //pms means Property Management Services
      this.selectedMngtServiceName = "residential"
    }  
    else {
      this.mngtServiceType = "rrm";
      this.selectedMngtServiceName = "property"
    }
  }


} 



 